import React from 'react';
import {
  getFirstAvailableUnit,
  getParentBlockById,
} from '../hooks/utils/iframe';
import { getParameterByName } from '../hooks/helpers';

const CourseIframeSecondaryMenu = ({ courseData }) => {
  let data = null;
  if (getParameterByName('unit_id') === null) {
    data = getParentBlockById(
      courseData.children,
      getFirstAvailableUnit(courseData).id
    );
  } else {
    data = getParentBlockById(
      courseData.children,
      getParameterByName('unit_id')
    );
  }
  let indices = data.foundIndices;

  return (
    <div className="secondary_menu">
      <div className="secondary_options">
        <a href="#" id="about" className="secondary_link">
          {courseData.children[indices[0]].display_name}
        </a>
        <div className="f_a dr">
          <strong className="bold-text-8 dr"></strong>
        </div>
        <a href="#" id="about" className="secondary_link">
          {courseData.children[indices[0]].children[indices[1]].display_name}
        </a>

        <div className="f_a dr">
          <strong className="bold-text-8 dr"></strong>
        </div>
        <a href="#" id="about" className="secondary_link">
          {
            courseData.children[indices[0]].children[indices[1]].children[
              indices[2]
            ].display_name
          }
        </a>
      </div>
    </div>
  );
};
export default CourseIframeSecondaryMenu;
